import { useMutation, useQueryClient } from '@tanstack/react-query';
import { teamQuery } from '@repo/domains-organization/team/team';
import { axios } from '@repo/http';
import { teamMemberQuery } from './get-team-member-list';
/** @deprecated Use ze-sdk equivalents. See docs/migration/DOMAIN_TO_SDK_MAPPING.md */ export function useUpdateMemberTeamRole() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (param)=>{
            let { teamId, memberId, data } = param;
            return axios.post("/v2/team/".concat(teamId, "/member/").concat(memberId), data);
        },
        onSuccess: async (res, param)=>{
            let { teamId, queryParams } = param;
            const invalidateQueryPromises = [
                queryClient.invalidateQueries(teamQuery.getById(teamId)),
                queryClient.invalidateQueries(teamMemberQuery.list(teamId, {
                    name: queryParams === null || queryParams === void 0 ? void 0 : queryParams.name
                }))
            ];
            await Promise.all(invalidateQueryPromises);
        }
    });
}
